/* eslint-disable function-paren-newline */
/* eslint-disable implicit-arrow-linebreak */
import { useQuery } from '@apollo/client';
import { useState } from 'react';
import { appendAccessToken } from '../../utils/user';
import {
  dismissLoadingMessage,
  displayErrorMessage,
  displayLoadingMessage,
} from '../../utils/helpers';
import { GET_SONGBOOK_SERIES } from '../../graphql/queries/songbook/songbookSeries';

const useGetSongbookSeries = () => {
  const [processedData, setProcessedData] = useState(null);

  const appendTokenToSongbookSeriesAssets = (series) => {
    const stringKeys = ['imageFileMedium', 'imageFileOriginal'];
    const modifiedSeries = { ...series };
    stringKeys.forEach((key) => {
      modifiedSeries[key] = appendAccessToken(modifiedSeries[key]);
    });
    return modifiedSeries;
  };

  const { loading } = useQuery(GET_SONGBOOK_SERIES, {
    onCompleted: (res) => {
      dismissLoadingMessage();
      if (res?.getSongbookSeries) {
        const modifiedSeries = res?.getSongbookSeries.map((series) =>
          appendTokenToSongbookSeriesAssets(series)
        );
        setProcessedData({ getSongbookSeries: modifiedSeries });
      } else {
        setProcessedData(res);
      }
    },
    onError: () => {
      dismissLoadingMessage();
      displayErrorMessage('Could not load songbook series');
    },
  });

  loading && displayLoadingMessage('Loading songbook series...');

  return { data: processedData };
};

export default useGetSongbookSeries;
